import { OnboardingSetupStep, StepTransitionTarget } from '../types'

interface StepTransition {
  continue: StepTransitionTarget
  skip: StepTransitionTarget
}

type OnboardingStepFlowMap = Partial<Record<OnboardingSetupStep, StepTransition>>

const standardOnboardingStepFlow: OnboardingStepFlowMap = {
  NAME_PHONE: { continue: 'INVOICES', skip: 'INVOICES' },
  INVOICES: { continue: 'INTENT', skip: 'INTENT' },
  INTENT: { continue: 'FINISH', skip: 'FINISH' },
}

const extendedOnboardingStepFlow: OnboardingStepFlowMap = {
  NAME_PHONE: { continue: 'INVOICES', skip: 'INVOICES' },
  INVOICES: { continue: 'WORK_STYLE', skip: 'WORK_STYLE' },
  WORK_STYLE: { continue: 'ACCOUNTING_MANAGEMENT', skip: 'ACCOUNTING_MANAGEMENT' },
  ACCOUNTING_MANAGEMENT: { continue: 'INTENT', skip: 'INTENT' },
  INTENT: { continue: 'FINISH', skip: 'FINISH' },
}

export const getOnboardingStepFlow = (isExtendedQuestionnaire: boolean): OnboardingStepFlowMap =>
  isExtendedQuestionnaire ? extendedOnboardingStepFlow : standardOnboardingStepFlow
